<div class="access-denied-container">
    <span><i class="pi pi-lock lock-icon"></i></span>
    <h3>You do not have permissions to view this page/application.</h3>
    <div class="body-1">Access Denied.</div>
</div>
